import { render } from "./TaxonPage.vue?vue&type=template&id=00f81b6b"
import script from "./TaxonPage.vue?vue&type=script&lang=js"
export * from "./TaxonPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__